import React, { useState } from 'react'
import { GatsbyImage as Image, getImage } from "gatsby-plugin-image"
import { convertToYoutubeEmbed } from '../../utilities/convertUrlToYoutubeEmbed'
import { renderContent } from '../../utilities/renderContent'
import { graphql } from "gatsby"

export default function VideoFullWidth({ data }) {
  const [videoClicked, setVideoClicked] = useState(false)
  const {
    videoTitle,
    placeholderImage,
    youtubeEmbedUrl
  } = data
  return (
    <>
      {videoTitle && (
        <div dangerouslySetInnerHTML={renderContent(videoTitle)}
          className="video__title text-2xl md:text-4xl hds-text-color font-heading text-center pt-10"
        />
      )}
      <div className="Video pt-10 pb-12">
        {videoClicked ? (
          <div className="video-container w-full">
            <iframe
              src={convertToYoutubeEmbed(youtubeEmbedUrl)}
              className="video__iframe"
              frameBorder='0'
              allow="autoplay; encrypted-media"
              allowFullScreen
              title="Youtube Video"
            />
          </div>
        ) : (
          <div onClick={() => setVideoClicked(true)}>
            <Image
              className="w-full h-full object-cover object-center"
              image={getImage(placeholderImage)}
              alt={placeholderImage.alt}
            />
          </div>
        )}
      </div>
    </>
  )
}

export const VideoFullWidthQuery = graphql`
  fragment VideoFullWidthComponent on DatoCmsVideoFullWidth {
    internal {
      type
    }
    id
    videoTitle
    youtubeEmbedUrl
    placeholderImage {
      alt
      gatsbyImageData
    }
  }
`